import React from 'react'
import './ImageStyleSheet.css';

function RogerSix() {
    window.scrollTo(0,0);
    return (
        <div className="container">
            <img src="/images/roger6.jpeg" className='img-view'/>
        </div>
    )
}

export default RogerSix
